const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/errors`;

function inferApp() {
  const seg = window.location.pathname.split('/')[1] || '';
  const known = ['giraffe','cult','framed','uncode','dash','soulsync','zephyr','verve','arx','xent','dashboard','library'];
  return known.includes(seg) ? seg : 'system';
}

function send(entry) {
  try {
    const payload = JSON.stringify({
      app: entry.app || inferApp(),
      message: String(entry.message || '').slice(0, 2000),
      stack: entry.stack ? String(entry.stack).slice(0, 4000) : null,
      url: window.location.href,
      severity: entry.severity || 'error',
      context: entry.context || null,
      timestamp: new Date().toISOString(),
    });
    // Use fetch with keepalive instead of sendBeacon. sendBeacon with
    // application/json Blob triggers a CORS preflight that it can't handle
    // cross-origin (Vercel frontend → Railway backend), and failures are
    // silent. fetch+keepalive survives page unload the same way beacon does
    // but gives us real CORS and real error handling.
    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
      mode: 'cors',
    }).catch(() => { /* never let logging break the app */ });
  } catch (_) { /* never let logging break the app */ }
}

export function logError(message, opts = {}) {
  send({ message, ...opts });
}

export function logAxiosError(error) {
  try {
    const resp = error.response;
    const config = error.config || {};
    send({
      message: resp?.data?.detail || resp?.data?.message || error.message || 'Request failed',
      severity: 'error',
      context: {
        method: (config.method || '').toUpperCase(),
        endpoint: config.url || '',
        status: resp?.status || null,
        responseDetail: resp?.data?.detail || resp?.data?.message || null,
      },
    });
  } catch (_) {}
}

export function initErrorLogger() {
  // 1. Uncaught exceptions
  const prevOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    send({ message: String(message), stack: error?.stack || `${source}:${lineno}:${colno}`, severity: 'error' });
    if (prevOnError) prevOnError(message, source, lineno, colno, error);
  };

  // 2. Unhandled promise rejections
  const prevUnhandled = window.onunhandledrejection;
  window.onunhandledrejection = (event) => {
    const reason = event.reason;
    send({
      message: reason?.message || String(reason),
      stack: reason?.stack || null,
      severity: 'error',
    });
    if (prevUnhandled) prevUnhandled(event);
  };

  // 3. Patch console.error
  const origConsoleError = console.error;
  console.error = (...args) => {
    origConsoleError.apply(console, args);
    try {
      const msg = args.map(a => (typeof a === 'string' ? a : JSON.stringify(a))).join(' ');
      if (!msg.includes('/api/errors')) {
        send({ message: msg.slice(0, 2000), severity: 'error' });
      }
    } catch (_) {}
  };

}
